import { render, staticRenderFns } from "./MessageContentPhoto.vue?vue&type=template&id=279bc7c0&scoped=true&"
import script from "./MessageContentPhoto.vue?vue&type=script&lang=js&"
export * from "./MessageContentPhoto.vue?vue&type=script&lang=js&"
import style0 from "./MessageContentPhoto.vue?vue&type=style&index=0&id=279bc7c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279bc7c0",
  null
  
)

export default component.exports